import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UtilsService } from '../../../core/services/utils.service';
import { AIModel, PlatformModelsResponse } from '../../../core/models/platform-models-response';
import { AdminService } from '../../../admin/admin.service';
import { Criteria } from '../../../core/models/criteria-dto';

@Component({
  selector: 'app-aimodel-selector',
  standalone: false,
  templateUrl: './aimodel-selector.component.html',
  styleUrl: './aimodel-selector.component.scss'
})
export class AimodelSelectorComponent implements OnInit {
  @Output() modelChanged = new EventEmitter<string>();

  criteriaList: Criteria[] = [];

  responseHardcoded = {
    "data": [
        {
            "id": "azure-gpt-4o-mini",
            "object": "model",
            "created": 1677610602,
            "owned_by": "openai"
        },
        {
            "id": "azure-gpt-4o",
            "object": "model",
            "created": 1677610602,
            "owned_by": "openai"
        },
        {
            "id": "genai_platform_llama33",
            "object": "model",
            "created": 1677610602,
            "owned_by": "openai"
        },
        {
            "id": "genai_platform_mistral",
            "object": "model",
            "created": 1677610602,
            "owned_by": "openai"
        },
        {
            "id": "gemini_flash_20_vertexai",
            "object": "model",
            "created": 1677610602,
            "owned_by": "openai"
        },
        {
            "id": "claude_4_sonnet_vertexai",
            "object": "model",
            "created": 1677610602,
            "owned_by": "openai"
        },
        {
            "id": "gemini_flash_lite",
            "object": "model",
            "created": 1677610602,
            "owned_by": "openai"
        },
        {
            "id": "azure_embeddings",
            "object": "model",
            "created": 1677610602,
            "owned_by": "openai"
        },
        {
            "id": "snowflake_embed_2",
            "object": "model",
            "created": 1677610602,
            "owned_by": "openai"
        },
        {
            "id": "genai_platform_qwen2.5",
            "object": "model",
            "created": 1677610602,
            "owned_by": "openai"
        },
        {
            "id": "genai_platform_deepseek_r1",
            "object": "model",
            "created": 1677610602,
            "owned_by": "openai"
        },
        {
            "id": "genai_platform_qwen3",
            "object": "model",
            "created": 1677610602,
            "owned_by": "openai"
        },
        {
            "id": "genai_platform_nemotron",
            "object": "model",
            "created": 1677610602,
            "owned_by": "openai"
        },
        {
            "id": "google_embeddings",
            "object": "model",
            "created": 1677610602,
            "owned_by": "openai"
        },
        {
            "id": "claude_37_vertexai",
            "object": "model",
            "created": 1677610602,
            "owned_by": "openai"
        },
        {
            "id": "gemini_flash",
            "object": "model",
            "created": 1677610602,
            "owned_by": "openai"
        },
        {
            "id": "gemini_pro_25_06_05_grounding_vertexai",
            "object": "model",
            "created": 1677610602,
            "owned_by": "openai"
        },
        {
            "id": "gemini_flash_lite_20_vertexai",
            "object": "model",
            "created": 1677610602,
            "owned_by": "openai"
        },
        {
            "id": "snowflake_embed",
            "object": "model",
            "created": 1677610602,
            "owned_by": "openai"
        },
        {
            "id": "genai_platform_qwen2.5-coder",
            "object": "model",
            "created": 1677610602,
            "owned_by": "openai"
        }
    ],
    "object": "list"
  };

  aiModelList: AIModel[] = [];
  constructor(private utilsService: UtilsService, private adminService: AdminService){

  }
  ngOnInit(): void {
    this.adminService.getCriteria().subscribe({
      next:((data: Criteria[])=>{
        this.criteriaList = data;
        this.modelChanged.emit(data[0].id);
      })
    })
    // this.utilsService.getAiModels().subscribe((response:PlatformModelsResponse)=>{
    //   this.aiModelList = response.data;
    // },
    // (error)=>{
    //   this.aiModelList = this.responseHardcoded.data;
    // })
  }
  handleChange(event:CustomEvent){
    this.modelChanged.emit(event.detail.value);
  }
}
